import React, { FC, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Page from 'components/Page';
import PageSpinner from 'components/PageSpinner/PageSpinner';
import SetTable from 'components/Table/SetTable';
import { TableContainer } from 'components/Table/Table';
import { useSet } from 'hooks/useSet';
import { useUser } from 'store/user/useUser';
import SetActionButtons from './molecules/SetActionButtons';
import * as Styles from './SetPage.styles';

type SetPageParams = {
  code: string;
};

const SetPage: FC = () => {
  const { code = '' } = useParams<SetPageParams>();
  const navigate = useNavigate();
  const { loading, set, dispatchSet } = useSet(code, true, true);
  const user = useUser();

  const isOwnedByMe = useMemo(() => {
    if (!user.isAuthenticated) return;
    return set.owned_by === user.user_id;
  }, [set.owned_by, user]);

  if (set.draft_exists && isOwnedByMe && set.code) {
    navigate(`/set/${set.code}/edit`);
  }

  return (
    <Page>
      {loading || !set || !user.isAuthenticated ? (
        <PageSpinner />
      ) : (
        <Styles.SetPageContainer>
          <Styles.SetHeader>
            <a href={`#${set.code}`}>
              <h1>{set.display_code}</h1>
            </a>
            <SetActionButtons currentUser={user} setDraft={set} updateSet={dispatchSet} />
          </Styles.SetHeader>
          <Styles.SetLinksList>
            {Object.keys(set.trays).map(trayID => (
              <Styles.SetLink key={trayID} href={`#${trayID}`}>
                {trayID}
              </Styles.SetLink>
            ))}
          </Styles.SetLinksList>
          <TableContainer>
            <SetTable set={set} dispatchSet={dispatchSet} disabled={true} />
          </TableContainer>
        </Styles.SetPageContainer>
      )}
    </Page>
  );
};

export default SetPage;
